import type { SmarticoDeepLinkPayload } from '../types';

function runDeepLinkWithRetry(deepLink: string, maxAttempts = 40): void {
  const tryRun = (): boolean => {
    const sdk = window._smartico;

    if (!sdk || typeof sdk.dp !== 'function') {
      return false;
    }

    try {
      sdk.dp(deepLink);

      return true;
    } catch {
      return false;
    }
  };

  if (tryRun()) {
    return;
  }

  let tries = 0;
  const handle = setInterval(() => {
    tries += 1;

    if (tryRun()) {
      clearInterval(handle);

      return;
    }

    if (tries >= maxAttempts) {
      clearInterval(handle);
    }
  }, 300);
}

// A mensagem chega via postMessage (sem garantia de origem), entao so
// navegamos para URLs http(s) do proprio host — evita open redirect e
// `javascript:` injetados por outras janelas/frames.
function parseSameHostUrl(rawDeepLink: string): URL | null {
  let url: URL;

  try {
    url = new URL(rawDeepLink);
  } catch {
    return null;
  }

  if (url.protocol !== 'https:' && url.protocol !== 'http:') {
    return null;
  }

  if (url.hostname !== window.location.hostname) {
    return null;
  }

  return url;
}

export function handleSmarticoDeepLink(payload: SmarticoDeepLinkPayload): void {
  if (!payload.deepLink) {
    return;
  }

  // Mesma regra do service worker oficial: URL absoluta navega
  // direto, dp:* via SDK que interpreta `dp:cashier`/`dp:gf_store`.
  if (/^https?:\/\//i.test(payload.deepLink)) {
    const safeUrl = parseSameHostUrl(payload.deepLink);

    if (safeUrl) {
      window.location.href = safeUrl.href;
    }
  } else {
    runDeepLinkWithRetry(payload.deepLink);
  }
}
